/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TitreDiplomeCertificationEditDto
 */
export interface TitreDiplomeCertificationEditDto {
    /**
     * 
     * @type {number}
     * @memberof TitreDiplomeCertificationEditDto
     */
    idtitreDiplomeCertification?: number;
    /**
     * 
     * @type {string}
     * @memberof TitreDiplomeCertificationEditDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TitreDiplomeCertificationEditDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the TitreDiplomeCertificationEditDto interface.
 */
export function instanceOfTitreDiplomeCertificationEditDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TitreDiplomeCertificationEditDtoFromJSON(json: any): TitreDiplomeCertificationEditDto {
    return TitreDiplomeCertificationEditDtoFromJSONTyped(json, false);
}

export function TitreDiplomeCertificationEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TitreDiplomeCertificationEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idtitreDiplomeCertification': !exists(json, 'idtitreDiplomeCertification') ? undefined : json['idtitreDiplomeCertification'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function TitreDiplomeCertificationEditDtoToJSON(value?: TitreDiplomeCertificationEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idtitreDiplomeCertification': value.idtitreDiplomeCertification,
        'description': value.description,
        'actif': value.actif,
    };
}

